import { render, staticRenderFns } from "./PersonalSettings.vue?vue&type=template&id=7cfa619c&scoped=true"
import script from "./PersonalSettings.vue?vue&type=script&lang=js"
export * from "./PersonalSettings.vue?vue&type=script&lang=js"
import style0 from "./PersonalSettings.vue?vue&type=style&index=0&id=7cfa619c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfa619c",
  null
  
)

export default component.exports